import React from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';
import { urlify } from '../../../utils/string';
import s from './Heading.scss';

const Heading = ({ content, attrs = {}, setup }) => {
	const style = {};
	const HeadingTag = `h${content?.level || '2'}`;
	if (attrs.textColor) style.color = attrs.textColor;
	if (attrs.textAlign) style.textAlign = attrs.textAlign;

	return (
		<div id={urlify(content.rawText)} className={[s.heading, ...(attrs.className ? attrs.className.map((cN) => s[`heading${cN}`]) : [])].join(' ')} style={style}>
			<HeadingTag className={[s.heading_inner, (attrs.fontSize ? `u_fontSize__${attrs.fontSize}` : null)].join(' ')} dangerouslySetInnerHTML={{ __html: purifier(content.rawText, {}, setup) }} />
		</div>
	);
};

export default hot(module)(Heading);
